<ngx-ui-loader></ngx-ui-loader>
@if (!isAuthenticated && isAuthenticating) {
  <div class="main-bg">
    <div class="user-login-box">Processing Login</div>
  </div>
}
@if (!isAuthenticated && !isAuthenticating) {
  <div class="main-bg">
    <div class="container blurred-box">
      <div class="user-login-box">
        <!--      <img src="../assets/rocc.svg" class="rocc-logo" alt="ROCC Logo" />-->
        <h1 class="product-title">{{ "scheduler.title" | translate }}</h1>
        <br />
        <!--    <p>Press the button below to sign in.</p>-->
        <button
          (click)="onLoginClick()"
          class="sign-in-button"
          color="primary"
          mat-flat-button
          aria-label="Sign in"
        >
          {{ "scheduler.menu.login" | translate }}
        </button>
        <div class="subtext">Client Version: {{ version }}</div>
      </div>
    </div>
  </div>
}
@if (isAuthenticated) {
  @if (!isHideMenu) {
    <span class="toolbar">
      <mat-toolbar
        [hidden]="isHideMenu"
        class="mat-elevation-z8 main-toolbar"
        color="primary"
      >
        <div class="toolbar-container">
          <div class="toolbar-section toolbar-start">
            @if (isAuthenticated) {
              <span class="mat-elevation-z2 time-display" color="primary">
                <app-stomp-status></app-stomp-status>
                {{ time | amDateFormat: "HH:mm:ss" }}
              </span>
            }
          </div>
          <div class="toolbar-section toolbar-center">
            <span class="d-none d-md-inline">
              @for (item of navigation; track item) {
                <button
                  [routerLink]="[item.link]"
                  class="nav-button override-nav-button"
                  mat-button
                  routerLinkActive="link-active"
                >
                  {{ item.label | translate }}
                </button>
              }
            </span>
          </div>
          <div class="toolbar-section toolbar-end">
            @if (isAuthenticated) {
              <app-follow-on-tool></app-follow-on-tool>
            }
            @if (isAuthenticated) {
              <app-recall-tool></app-recall-tool>
            }
            @if (isAuthenticated) {
              <app-reservation-alert-tool></app-reservation-alert-tool>
            }
            @if (isAuthenticated) {
              <app-held-tickets-tool></app-held-tickets-tool>
            }
            @if (isAuthenticated) {
              <app-alert-tool></app-alert-tool>
            }
            <app-solver-status-widget></app-solver-status-widget>
            @if (!isAuthenticated) {
              <button
                (click)="onLoginClick()"
                class="sign-in-button"
                mat-button
              >
                {{ "scheduler.menu.login" | translate }}
              </button>
            }
            @if (isAuthenticated) {
              <button
                [matMenuTriggerFor]="toolbarUserMenu"
                mat-icon-button
                aria-label="Open user menu"
                title="Open user menu"
              >
                <mat-icon
                  class="fa-2x"
                  fontIcon="fa-user-circle"
                  fontSet="fas"
                ></mat-icon>
              </button>
            }
            <mat-menu #toolbarUserMenu="matMenu">
              <div disabled mat-menu-item>
                Logged in as {{ userDisplayName }}
              </div>
              <div disabled mat-menu-item>Client Version: {{ version }}</div>
              <div
                (click)="updateService.checkForUpdates()"
                [disabled]="!updateService.isEnabled"
                mat-menu-item
              >
                {{
                  updateService.isEnabled
                    ? "Check for updates"
                    : "Updates not supported"
                }}
              </div>
              <div disabled mat-menu-item>
                Server Version: {{ serverVersion }}
              </div>
              @if (isAdmin) {
                <div disabled mat-menu-item>Administrator Role</div>
              }
              @if (isPlanner) {
                <div disabled mat-menu-item>Planner Role</div>
              }
              @if (isViewer) {
                <div disabled mat-menu-item>Viewer Role</div>
              }
              @if (allowResourceLocking) {
                <div disabled mat-menu-item>Resource Lock Permission</div>
              }
              @if (allowForceBooking) {
                <div disabled mat-menu-item>Force Booking Permission</div>
              }
              @if (allowPriorityReservation) {
                <div disabled mat-menu-item>
                  Priority Reservation Permission
                </div>
              }
              @if (!isPlanner && !isAdmin && !isViewer) {
                <div disabled mat-menu-item>User Group Not Assigned</div>
              }
              @if (telemetryEnabled) {
                <div mat-menu-item>Telemetry Enabled</div>
              }
              <button mat-menu-item routerLink="about">
                <mat-icon fontIcon="fa-info" fontSet="fas"></mat-icon>
                About
              </button>
              <button (click)="onLogoutClick()" mat-menu-item>
                <mat-icon fontIcon="fa-power-off" fontSet="fas"></mat-icon>
                <span>{{ "scheduler.menu.logout" | translate }}</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </mat-toolbar>
    </span>
  }
  <div class="wrapper {{ isHideMenu ? 'hide-wrapper' : 'show-wrapper' }}">
    <div
      [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.path"
      class="content"
    >
      <router-outlet #o="outlet"></router-outlet>
    </div>
  </div>
}
